import { oldApi } from '../lib/api';

export class SearchShipApi {
  async getList(params, id, year) {
    return await oldApi.post(`/ApiShips/ship_cruises/${id}/${year}`, params);
  }
}
